import React, { useEffect, useState } from "react";
import CargarExcelCampo from "./InventarioActividadesComponents/CargaExcelCampo";
import ExcelCargados from "./InventarioActividadesComponents/ExcelCargados";
import { getWeekNumber } from "../../../utils/Common";
import VerActividaesV2 from "./InventarioActividadesComponents/VerActividaesV2";
import CargarDiccionarioTuneles from "./InventarioActividadesComponents/CargarDiccionarioTuneles";

const PlanCampoExternoExcel = () => {
  const [section, setsection] = useState(4);
  const [week, setweek] = useState('');

  useEffect(() => {
    let ww = getWeekNumber();
    let semana = ww[1] < 10 ? `0${ww[1]}` : ww[1];
    let anio = (`${ww[0] - 2000}`);
    setweek(`${anio}${semana}`);
  }, [])

  const sectionButton = (seccion, text) => {
    let classname = seccion === section ? "btn btn-warning text-bold border border-dark m-2" : 'btn btn-light border shadow m-2';
    return (
      <button className={classname} style={{ maxWidth: '220px' }} onClick={() => { setsection(seccion) }}>{text}</button>
    );
  }

  return (
    <div className="w-100 h-100 bg-white border round-m dosis shadow-lg p-0" style={{ overflow: "auto" }} >
      <div className="w-100 m-0 p-0" id='contenedor_actividad_0' />
      <div className="border-b rounded-t p-2 bg-orange-800">
        <h5 className="font-bold uppercase text-white p-0 m-0">
          Asociación de inventarios de campo externo
        </h5>
      </div>
      <div className='row justify-content-center wv-100 p-0 m-0'>
        {sectionButton(4, 'Cargar plan de campo')}
        {sectionButton(5, 'Planes de campo cargados')}
        {sectionButton(6, 'Diccionario de túneles')}
      </div>

      {section === 3 && <VerActividaesV2 historial={true} />}
      {section === 4 && <CargarExcelCampo />}
      {section === 5 && <ExcelCargados />}
      {section === 6 && <CargarDiccionarioTuneles />}

    </div>
  );
}

export default PlanCampoExternoExcel;
